export default {
    UPDATE_MAIN_SECURITY: 'UPDATE_MAIN_SECURITY',
    UPDATE_OVERVIEW_SECURITY: 'UPDATE_OVERVIEW_SECURITY',
    UPDATE_SNAPSHOTS: 'UPDATE_SNAPSHOTS',
    UPDATE_ORDER_BOOKS: 'UPDATE_ORDER_BOOKS',
    UPDATE_CANDLE_CHANGE_BOOKS: 'UPDATE_CANDLE_CHANGE_BOOKS',
    REMOVE_CANDLE_CHANGE_BOOK_ENTRIES: 'REMOVE_CANDLE_CHANGE_BOOK_ENTRIES',
    UPDATE_GREEKS: 'UPDATE_GREEKS',
    UPDATE_LIVE_DATA: 'UPDATE_LIVE_DATA',
    SAVE_EXPRESSION: 'SAVE_EXPRESSION',
    SAVE_USER_EXPRESSIONS: 'SAVE_USER_EXPRESSIONS',
    ADD_OR_UPDATE_USER_EXPRESSION: 'ADD_OR_UPDATE_USER_EXPRESSION',
    DELETE_USER_EXPRESSIONS: 'DELETE_USER_EXPRESSIONS',
    SET_SECURITIES_LOADED: 'SET_SECURITIES_LOADED',
}